package com.ives.modules.vrc;

class ReconstructionSettings {
	public var screenWidth:UInt;
	public var screenHeight:UInt;
	public var shading:Bool;
	public var step:UInt;
	public var timeout:UInt;

	public function new(screenWidth:UInt, screenHeight:UInt, ?shading:Bool = false, ?step:UInt = 1, ?timeout:UInt = 1000) {
		this.screenWidth = screenWidth;
		this.screenHeight = screenHeight;
		this.shading = shading;
		this.step = step;
		this.timeout = timeout;
	}
}
